import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core-services/auth.service";
import { Router } from "@angular/router";
import { openLoginModal } from 'src/app/core-services/eventEmitter';

@Component({
  selector: "public-header-component",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  curentPage: string;
  isSignedIn: boolean = false;
  openLoginModal = openLoginModal;
  constructor(private authenticationService: AuthService, private router: Router) {

  }
  ngOnInit() {
    var currentUser = localStorage.getItem('currentUser');
    if (currentUser != null && currentUser != undefined) {
      this.isSignedIn = true;
    }
  }
  signOut()
  {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
